import "/src/css/legacy/funds.css"
import "/src/js/legacy/fund-chart.js"
(function() {

	"use strict";

	$(function () {

		$(document).tooltip({
			position: {
				my: "center+2 bottom+45",
				at: "center bottom",
				using: function (position, feedback) {
					$(this).css(position);
					$("<div>")
						.addClass("arrow")
						.addClass(feedback.vertical)
						.addClass(feedback.horizontal)
						.appendTo(this);
				}
			}
		});

	});

	    // Grab an element.
	var header = document.querySelector("header"),
        // Construct an instance of Headroom, passing the element.
	    headroom = new Headroom(header, {
		tolerance: {
			down: 0,
			up: 0
		},
		offset: 100
	}).init();

	$(document).ready(function () {

		// Fund category Accordion - When category drop-down arrow is clicked.

		$( ".fund-category-heading" ).click(function(){

		  $(this).nextAll('.fund-list').slideToggle(450, "easeOutExpo");
		  $(this).nextAll('ul').slideToggle(450, "easeOutExpo");
		  $(this).children("a").toggleClass( "fund-category-heading-maximise" );

		});


		// Fund Accordion - When arrow is clicked.
		$(".fund-links .fund-quicklook").click(function () {

			$(this).first().parent().prev('h2')[0].click();

			var name = $(this).parent().siblings('h2').text(),
                trimmedName = name.substring(0, name.indexOf('('));

			$(this).toggleClass("active");
			/* Adds top border to div under expanded fund */
			$(this).parentsUntil(".fund-list ul").next(".fund").children(".fund-header").toggleClass("fund-header-border");
			var actualPriceID = $(this).parents(".fund-header").siblings(".fund-content").children(".fund-content-right").children(".chartdiv").attr('value');

		});

		var listofPdfs = [],
            allSelectedFileSizes = [];

		$('input').iCheck({
			checkboxClass: 'icheckbox_square-red',
			radioClass: 'iradio_square-red',
			increaseArea: '30%' // optional
		});

		/*! When "All" is checked / Unchecked */
		$('.fund-checkbox.all').on('ifChecked', function () {

			$(this).closest("ul.list").find(".fund-checkbox:not(:disabled)").iCheck('check');

		});

        $('.pdf-download').click(function () {

			listofPdfs = listofPdfs.filter(Boolean);// To clear blank or undefined values on the array.

            if (listofPdfs.length > 1) {

                var fundPdfs = listofPdfs;

                window.gaTracking.sendEvent('Download', window.location.pathname, 'Pdf Download', 'Downloading multiple pdfs', '', '');

                downloadFundPdfs(fundPdfs);

			} else {

				//when the user choose to download one item I use the javascript method to download instead of calling the controller action method
				download(listofPdfs.toString());

			}
			listofPdfs = [];
			allSelectedFileSizes = [];
		});

        $('.downloadallbtn').click(function () {

			var allCheckBoxes = [];

			$('.fund-checkbox').each(function () {

			    // Loop through each checkbox
				allCheckBoxes.push($(this).not(".all").parent().siblings("label").children("a").attr("href"));

			});

            allCheckBoxes = allCheckBoxes.filter(Boolean);

            var pdfistPerOne = allCheckBoxes.toString(),
                dataSet = { pdfistPerOne: allCheckBoxes },
                fundPdfs = allCheckBoxes;

            window.gaTracking.sendEvent('Download', window.location.pathname, 'Pdf Download', 'Downloading all pdfs', '', '');

            downloadFundPdfs(fundPdfs);

			allCheckBoxes = [];

        });

        function downloadFundPdfs(fundPdfs) {
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                var a;
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    // Trick for making downloadable link
                    a = document.createElement('a');
                    a.href = window.URL.createObjectURL(xhttp.response);
                    // Give filename you wish to download
                    a.download = "MandG_Fund_Information.zip";
                    a.style.display = 'none';

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(xhttp.response, a.download);
                    } else {
                        document.body.appendChild(a);
                        a.click();
                    }
                }

            };
            // Post data to URL which handles post request
            xhttp.open("POST", "/api/services/zipAllPdfs");
            xhttp.setRequestHeader("Content-Type", "application/json", "application/force-download");
            // You should set responseType as blob for binary responses
            xhttp.responseType = 'blob';
            xhttp.send(JSON.stringify(fundPdfs));
        }


		$('.fund-checkbox').on('ifUnchecked', function (event) 
		{
			$(this).parentsUntil(".fund-header-right").children().find(".fund-checkbox.all").iCheck('uncheck');
			/*Removing the value of the checkbox that has been deselected from the array*/
			var index = $.inArray($(this).not(".all").parent().siblings("label").children("a").attr("href"), listofPdfs);
			if (index !== -1) {     /*avoiding the chopping off of the last item of the array as the splice method accepts negative numbers*/
				listofPdfs.splice(index, 1);
				allSelectedFileSizes.splice(index, 1);
			}
		});

		var $checkboxes = $(".fund-checkbox:not(.all)");

		/*! Clearing the cart */
		$('#cart-clear').click(function () {
			$(".fund-checkbox").iCheck('uncheck');
		});

		/*! Detects when Cart should fly out or be hidden */
		$('.fund-checkbox').on('ifChecked', function () 
		{
			var clickedCheckBox = $(this).not(".all").parent().siblings("label");
			/*Populating the array values of selected checkboxes*/
			listofPdfs.push(clickedCheckBox.children("a").attr("href"));
			allSelectedFileSizes.push(clickedCheckBox.attr("value"));
			updateCartData();
			
			$('.cart').show("drop", { direction: 'down' }, 200, "easeOutExpo");
			
		});

		$('.fund-checkbox').on('ifDisabled', function () 
		{
			$('.fund-checkbox').iCheck('disable');
		});

		$('.fund-checkbox').on('ifUnchecked', function () {
			updateCartData();
			if (countActiveCheckboxes() === 0) {
				$('.cart').hide("drop", { direction: 'down' }, 200, "easeOutExpo");
			}
		});
		
		function countActiveCheckboxes() {

			return listofPdfs.length;

		}

		function updateCartData() {

			$(".cart-text").text(allSelectedFileSizes.filter(Boolean).length + " files selected");

		}

	});


	$(".fund-category").each(function(){
		if( !$(this).children(".fund-list").length > 0){
			$(this).hide();
		} 
	});


})();
